// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import './Button.scss';

type Props = {
  theme: void | 'default' | 'outline' | 'paper' | 'gray' | 'transparent',
  confirm?: boolean,
  cancel?: boolean,
  violetFont?: boolean,
  className?: string,
  to?: ?string,
  button?: boolean,
  children: Node,
  large?: boolean,
  fullWidth?: boolean,
  color?: string,
  desktop?: boolean,
};

const Button = ({
  theme,
  children,
  confirm,
  cancel,
  violetFont,
  className,
  desktop,
  to,
  large,
  fullWidth,
  color,
  button,
  ...rest
}: Props) => {
  const processedClassName = cx('Button', theme, className, color, {
    desktop,
    confirm,
    cancel,
    violetFont,
    large,
    fullWidth,
    button,
  });
  if (to) {
    return (
      <Link className={processedClassName} to={to} {...rest}>
        {children}
      </Link>
    );
  } else if (button) {
    return (
      <button className={processedClassName} {...rest}>
        {children}
      </button>
    );
  }
  return (
    <button className={processedClassName} {...rest}>
      {children}
    </button>
  );
};

Button.defaultProps = {
  theme: 'default',
  confirm: false,
  cancel: false,
  violetFont: false,
  className: '',
  to: null,
  large: false,
  fullWidth: false,
  color: '',
  desktop: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js